<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4Rz32D/tc-custom/9781453251966.jpg?1733118759198" alt="This image is the cover for the book Kaleidoscope, The St-Cyr and Kohler Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kaleidoscope, The St-Cyr and Kohler Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>In Provence, St-Cyr and Kohler investigate an old-fashioned murder</b>The train ride from Paris is supposed to take four hours, but a Resistance bomb has snarled the tracks, and detectives Jean-Louis St-Cyr and Hermann Kohler are fourteen hours behind schedule. By the time they arrive in Provence, they are travel-weary but intrigued. Even in wartime, it’s rare to investigate a murder by crossbow. The woman was in her early fifties, with well-made clothing and opal earrings that indicate that, until war came, she was wealthy. The crossbow bolt was barbed, and as she tried to pull it out, it shredded her heart. St-Cyr and Kohler quickly learn why the villagers are loath to cooperate: The woman was a smuggler, killed to protect the black market that the inhabitants of this frigid, war-wracked countryside cannot survive without.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. Robert Janes
      </h2>
      
      <p class="authorDescription body article">J. Robert Janes (b. 1935) is a mystery author best known for writing historical thrillers. Born in Toronto, he holds degrees in mining and geology, and worked as an engineer, university professor, and textbook author before he started writing fiction. He began his career as a novelist by writing young adult books, starting with <i>The Odd-Lot Boys and the Tree-Fort War</i> (1976). He wrote his last young adult novel, <i>Murder in the Market</i>, in 1985, by which time he had begun writing for adults, starting with the four-novel Richard Hagen series.&#160;In 1992, Janes published <i>Mayhem</i>, the first in the long-running St-Cyr and Kohler series for which he is best known. These police procedurals set in Nazi-occupied France have been praised for the author&rsquo;s attention to historical detail, as well as their swift-moving plots. The thirteenth in the series, <i>Bellringer</i>, was published in 2012.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e556752